import { makeStyles, Theme, createStyles } from "@material-ui/core";
import React, { Fragment, useMemo } from "react";
import { observer } from "mobx-react";
import clsx from "clsx";
import SearchInput from "../../../../Search/FilterBar/SearchInput";
import VolunteersFilterPopper, { VolunteerFilterOptionCollections } from "./VolunteersFilterPopper";
import { DialogState } from "../../../../../stores/models/DialogState";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        actionButton: {
            color: theme.palette.action.active
        },
        searchInput: {
            maxWidth: '300px',
            marginRight: theme.spacing(1)
        },
    }),
);

interface VolunteerSearchAndFilterToolbarProps extends VolunteerFilterOptionCollections {
    searchQuery?: string;
    onSearchInputChanged: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const VolunteerSearchAndFilterToolbar = observer((props: VolunteerSearchAndFilterToolbarProps) => {

    const classes = useStyles();
    const state = useMemo(() => new DialogState(), []);

    /********* Render *********/

    return (
        <Fragment>
            <SearchInput
                searchText={props.searchQuery || ''}
                placeholder={"Search"}
                outlined
                onChange={props.onSearchInputChanged}
                className={clsx(classes.actionButton, classes.searchInput)}
            />
            <VolunteersFilterPopper
                state={state}
                roleOptions={props.roleOptions}
                statusOptions={props.statusOptions}
                className={classes.actionButton}
            />
        </Fragment>
    );
});

export default VolunteerSearchAndFilterToolbar;